export const complaintStatusEnum = {
    "PENDING": "Pending",
    "ACCEPT": "In-Progress",
    "COMPLETE": "Completed",
    "REJECT": "Rejected"
}